import useFetchDashboardBotPerformance from "../../../hooks/api/useFetchDashboardBotPerformance";
import styles from "../../../styles/Components/bot/bot-overview/BotOverviewContent.module.css";
import BotList from "./BotList";
import BotOverall from "./BotOverall";

function BotOverviewContent() {

  useFetchDashboardBotPerformance();

  return (
    <div className={styles.container}>
      <BotList />
      <BotOverall />
    </div>
  );
}

export default BotOverviewContent;
